import styled from 'styled-components/macro';

export const PrivacyContainer = styled.div`
  padding: 2em 5em;
`;

export const PolicyText = styled.p`
  white-space: pre-line;
`;
